import React from 'react';
import {
  View,
  StyleSheet,
  Text,
  ScrollView,
} from 'react-native';
import {useTheme} from 'react-native-paper';
import Icon from 'react-native-vector-icons/MaterialIcons';
import {ActionButton} from '../../shared/components/ActionButton';
import {MainLayout} from '../layouts/MainLayout';

interface DeliveryErrorScreenProps {
  navigation: any;
  route: {
    params: {
      errorMessage: string;
    };
  };
}

export const DeliveryErrorScreen: React.FC<DeliveryErrorScreenProps> = ({
  navigation,
  route,
}) => {
  const {errorMessage} = route.params;
  const theme = useTheme();

  const handleGoToDashboard = () => {
    const parent = navigation.getParent();
    if (parent?.navigate) {
      parent.navigate('Dashboard');
    } else {
      navigation.navigate('Dashboard');
    }
  };

  const handleTryAgain = () => {
    // Go back to try again
    navigation.goBack();
  };

  return (
    <MainLayout navigation={navigation} title="Error en la Entrega">
      <View style={[styles.container, {backgroundColor: theme.colors.background}]}>
        <ScrollView 
          contentContainerStyle={styles.scrollContent}
          showsVerticalScrollIndicator={false}>
          <View style={styles.content}>
            {/* Error Icon */}
            <View style={[styles.iconContainer, {backgroundColor: '#FFEBEE'}]}>
              <Icon name="error" size={80} color="#F44336" />
            </View>

            {/* Error Message */}
            <Text style={[styles.title, {color: theme.colors.onBackground}]}>
              Error en la Entrega
            </Text>

            <Text style={[styles.message, {color: theme.colors.onSurfaceVariant}]}>
              No se pudo completar la entrega del beneficio
            </Text>

            {/* Error Details */}
            <View style={[styles.errorCard, {backgroundColor: '#FFEBEE'}]}>
              <View style={styles.errorHeader}>
                <Icon name="info" size={20} color="#F44336" />
                <Text style={[styles.errorTitle, {color: '#C62828'}]}>
                  Detalles del Error
                </Text>
              </View>
              <Text style={[styles.errorText, {color: '#C62828'}]}>
                {errorMessage}
              </Text>
            </View>

            {/* Help Text */}
            <View style={[styles.helpCard, {backgroundColor: theme.colors.surfaceVariant}]}>
              <Icon name="help-outline" size={20} color={theme.colors.onSurfaceVariant} />
              <Text style={[styles.helpText, {color: theme.colors.onSurfaceVariant}]}>
                Si el problema persiste, contacta al administrador del sistema
              </Text>
            </View>
          </View>
        </ScrollView>

        {/* Action Buttons */}
        <View style={[styles.actions, {backgroundColor: theme.colors.background}]}>
          <ActionButton
            icon="home"
            label="Ir al Inicio"
            variant="outlined"
            onPress={handleGoToDashboard}
            flex={1}
          />
          <ActionButton
            icon="refresh"
            label="Reintentar"
            variant="contained"
            onPress={handleTryAgain}
            flex={1}
          />
        </View>
      </View>
    </MainLayout>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
  },
  scrollContent: {
    flexGrow: 1,
  },
  content: {
    flex: 1,
    alignItems: 'center',
    justifyContent: 'center',
    padding: 24,
    paddingBottom: 120,
  },
  iconContainer: {
    width: 140,
    height: 140,
    borderRadius: 70,
    alignItems: 'center',
    justifyContent: 'center',
    marginBottom: 32,
  },
  title: {
    fontSize: 34,
    fontWeight: 'bold',
    marginBottom: 12,
    textAlign: 'center',
  },
  message: {
    fontSize: 20,
    textAlign: 'center',
    marginBottom: 24,
    lineHeight: 28,
  },
  errorCard: {
    width: '100%',
    padding: 16,
    borderRadius: 12,
    marginBottom: 20,
  },
  errorHeader: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 8,
    marginBottom: 8,
  },
  errorTitle: {
    fontSize: 18,
    fontWeight: '600',
  },
  errorText: {
    fontSize: 18,
    lineHeight: 24,
    marginLeft: 28,
  },
  helpCard: {
    width: '100%',
    flexDirection: 'row',
    alignItems: 'center',
    gap: 12,
    padding: 16,
    borderRadius: 12,
  },
  helpText: {
    flex: 1,
    fontSize: 18,
    lineHeight: 24,
  },
  actions: {
    position: 'absolute',
    bottom: 0,
    left: 0,
    right: 0,
    flexDirection: 'row',
    gap: 12,
    paddingHorizontal: 16,
    paddingTop: 20,
    paddingBottom: 32,
    borderTopWidth: 1,
    borderTopColor: '#e5e7eb',
    shadowColor: '#000',
    shadowOffset: {width: 0, height: -2},
    shadowOpacity: 0.1,
    shadowRadius: 4,
    elevation: 5,
  },
});
